import axios from "axios";
import { ApiKey, BaseUrl } from "../global";

export const getCNs = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/AddressLabel/GetCNs', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const GetBulkCNs = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/AddressLabel/GetBulkCNs', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}


export const generateAddressLabels = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/AddressLabel/GenerateAddressLabels', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}

export const generateAddressLabelsStickers = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/AddressLabel/GenerateAddressLabelsStickers', data, {
            headers: {
                key: ApiKey,
            },
            responseType: 'blob'
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export const GetAddressLabelLogo = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/AddressLabel/GetAddressLabelLogo', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}
